"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAWSCDKConfig = exports.defaultComputDeploymentConfig = void 0;
const config_1 = require("@root/config");
const resolvedEnvironmentVariables_1 = require("../resolvedEnvironmentVariables");
const { projectCode, stage } = resolvedEnvironmentVariables_1.resolvedEnvironmentVariables;
let defaultEnvironmentComputeDeploymentConfig = (projectCode === 'i3012' || ['test', 'prod'].includes(stage)) ? 'FARGATE' : 'LAMBDA';
if (projectCode === 'i3012' && stage === 'test') {
    defaultEnvironmentComputeDeploymentConfig = 'LAMBDA';
}
exports.defaultComputDeploymentConfig = {
    networkData: {
        computeService: defaultEnvironmentComputeDeploymentConfig
    },
    fanOut: {
        computeService: defaultEnvironmentComputeDeploymentConfig
    },
    entityState: {
        computeService: 'LAMBDA' // defaultEnvironmentComputeDeploymentConfig
    }
};
const defaultInterfaceEndpointDeployment = {
    dev: {
        timestream: false,
        cloudwatch: false,
        sns: false,
    },
    test: {
        timestream: false,
        cloudwatch: false,
        sns: false,
    },
    prod: {
        timestream: false,
        cloudwatch: false,
        sns: false,
    },
};
exports.defaultAWSCDKConfig = {
    ComputeDeploymentConfig: exports.defaultComputDeploymentConfig,
    Cognito: {
        groupDefinitions: [],
        userInvitationConfig: {
            emailSubject: `${projectCode.substring(0, 4)}-${stage} User Registration`,
            emailBody: `{username}, you have been invited to register as a user of ${projectCode.substring(0, 4)} at app.${stage}.${projectCode.substring(0, 4)}.${config_1.parentHostedZoneName}
            Your password is {####}, this can be changed after logging in.`,
        },
    },
    Lamdba: {
        [`${projectCode}-${stage}-CalculatedState`]: {
            projectFunctionProps: {
                environment: {
                    DEFAULT_CANARY_ENV: 'DEFAULT',
                    CANARY_TEST_ENVARS: 'DEFAULT',
                },
            },
            /** used by cloudwatch alerts to configure settings for this lambda */
            alarmConfig: {
                metricInvocations: {
                    threshold: 1,
                    evaluationPeriods: 1,
                    alarmDescription: 'Alarm if Calculate state is involed less than once in 1 evaluation period',
                    comparisonOperator: 'LessThanThreshold',
                    treatMissingData: 'breaching',
                },
            },
        },
    },
    VPC: {
        interfaceEndpointDeployment: defaultInterfaceEndpointDeployment,
    },
};
